<!-- svelte-ignore a11y-no-redundant-roles -->
<nav class="navbar is-primary" role="navigation" aria-label="main navigation">
  <div class="navbar-brand">
    <!-- svelte-ignore a11y-invalid-attribute -->
    <a class="navbar-item" href="#">
      <img alt="Thermal Imaging Center logo" src="images/TIC_Logo_200.png" width="125" height="30" />
    </a>

    <!-- svelte-ignore a11y-missing-attribute -->
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-interactive-supports-focus -->
    <a
      role="button"
      class="navbar-burger"
      aria-label="menu"
      aria-expanded="false"
      data-target="navbarBasic"
      on:click={() => { document.querySelector('#navbarBasic').classList.toggle('is-active') }}>
      <span aria-hidden="true" />
      <span aria-hidden="true" />
      <span aria-hidden="true" />
      <span aria-hidden="true" />
    </a>
  </div>

  <div id="navbarBasic" class="navbar-menu">
    <div class="navbar-start">
      <a href="/clients" class="navbar-item" on:click={() => { document.querySelector('#navbarBasic').classList.toggle('is-active') }}> Clients </a>
      <a href="/transactions" class="navbar-item" on:click={() => { document.querySelector('#navbarBasic').classList.toggle('is-active') }}> Transactions </a>
      <a href="/mileage" class="navbar-item" on:click={() => { document.querySelector('#navbarBasic').classList.toggle('is-active') }}> Mileage </a>
      <a href="/time" class="navbar-item" on:click={() => { document.querySelector('#navbarBasic').classList.toggle('is-active') }}> Time </a>
      <a href="/reports" class="navbar-item" on:click={() => { document.querySelector('#navbarBasic').classList.toggle('is-active') }}> Report </a>
      <a href="/metrics" class="navbar-item" on:click={() => { document.querySelector('#navbarBasic').classList.toggle('is-active') }}> Metrics </a>
    </div>

    <div class="navbar-end">
      <!-- <div class="navbar-item">
        <div class="buttons">
          <button type="button" id="SignIn" class="btn btn-secondary" onclick="signIn()">
            Sign In
          </button>
        </div>
      </div> -->
    </div>
  </div>
</nav>
